import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AutoGallery } from './components/AutoGallery';
import { Motivations } from './components/Motivations';
import { HowItWorks } from './components/HowItWorks';
import { CreationsGallery } from './components/CreationsGallery';
import { MainGuide } from './components/MainGuide';
import { Bonuses } from './components/Bonuses';
import { TemplateLibrary } from './components/TemplateLibrary';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { originalGallery } from './data/galleries';
import { siteConfig } from './data/siteConfig';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel(siteConfig.metaPixelId);
  useEffect(() => {
    document.title = `${siteConfig.brandName} — Il kit creativo`;
    document.documentElement.lang = 'it';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mjgczu7zmpqf">
      <div className="min-h-screen w-full [overflow-x:clip] bg-ivory font-sans text-ink selection:bg-coral-deep selection:text-white" data-id="element-1" data-mp="3rbzn2h7gv2qh">
        <AnnouncementBar data-id="element-2" data-mp="5ggxfcks0yi" />
        <Header data-id="element-3" data-mp="7st1bvnjh3n" />
        <main id="contenuto" data-id="element-4" data-mp="2zld2xbxu5jcl">
          <Hero data-id="element-5" data-mp="2zm4xcjfp5b1a" />
          <AutoGallery items={originalGallery} label="Esempi di decorazioni con effetto vetrata" data-id="element-6" data-mp="2zmo6pbra6r3p" />
          <Motivations data-id="element-7" data-mp="33n6xr3lcnt4u" />
          <HowItWorks data-id="element-8" data-mp="33oi3h8ycvayl" />
          <CreationsGallery data-id="element-9" data-mp="38m1fe27kzbnd" />
          <MainGuide data-id="element-10" data-mp="38kqau06b9zv7" />
          <Bonuses data-id="element-11" data-mp="38kgkucl9nspi" />
          <TemplateLibrary data-id="element-12" data-mp="38o4gpie6or7e" />
          <Testimonials data-id="element-13" data-mp="3dle28mygcipy" />
          <AutoGallery items={originalGallery} label="Altre idee di decorazioni con effetto vetrata" data-id="element-14" data-mp="3dlntedv8gvx8" />
          <Offer data-id="element-15" data-mp="nur948fv0n11" />
          <FAQ data-id="element-16" data-mp="nvas7sh8xhgn" />
        </main>
        <Footer data-id="element-17" data-mp="sunbk38ws6eh" />
      </div>
    </MotionConfig>;
}